import React, { useEffect, useState } from "react";
import axiosRequest from "../../../../redux/slices/universal/axiosService";
import { ENDPOINTS } from "../../../../redux/apiConfig";
import { Backdrop, LogoLoader, TableAdv } from "../../../../components";
import { mapTableRows } from "../../../../utils";
import { usePagination } from "../../../../hooks";
import { fetchAllJobs } from "../../../../redux/slices/accountDetails/accountDetailsAPi";
import { getEndOfDay, getStartOfDay } from "../../../../utils/common";
import { getTotalCountApi } from "../../../../redux/slices/totalCount/totalCountApi";
import { fetchAllJobsApi } from "../../../../redux/slices/bdmjobs/bdmjobsApi";
import {
  getPlacementsListApi,
  getAdminBackoutsListApi,
  getAdminAllJobsListApi,
  getTotalAccountsFromJobsApi
} from "../../../../redux/slices/atsDashboard/atsDashboardApi";
import { formatWords2 } from "../../../../utils/stringUtils";


const KpiDashboardViewModal = ({ selectedKpi, onClose, finalDataDuration }) => {
  function getSiteName(url) {
    try {
      const { hostname } = new URL(url);
      let name = hostname
        .replace(/^www\./, "")
        .split(".")[0]
        .replace(/-/g, " ");
      name = name.charAt(0).toUpperCase() + name.slice(1);
      return name;
    } catch {
      return "Link";
    }
  }
  const normalizeUrl = (url) => {
    if (!url) return "#";
    if (!/^https?:\/\//i.test(url)) {
      return "https://" + url;
    }
    return url;
  };
  const getRowId = (item, index) => {
    return (
      item?._id ||
      item?.uiid ||
      `${index}-${Math.random()}`
    );
  };
  const KPI_CONFIG = {
    totalAccounts: {
      columns: [
        { key: "clientName", label: "Company Name" },
        { key: "companyWebsite", label: "Company Website" },
        { key: "companyDomain", label: "Company Domain" },
        { key: "industry", label: "Industry" },
        { key: "addedBy", label: "Added By" },
        { key: "addedOn", label: "Added On" },
      ],
      rows: [],
    },

    positivesjobs: {
      columns: [
        { key: "clientName", label: "Client Name" },
        { key: "title", label: "Job Title" },
        { key: "location", label: "Job Location" },
        {
          key: "jobDescription",
          label: "Job Description",
          render: (row) => (
            <div className="flex-1 flex items-center gap-2">
              {/* {row.jobDescription && typeof row.jobDescription === "string" ? */}
              {row.jobDescription &&
                row.jobDescription.trim() !== "" &&
                row.jobDescription.trim() !== "-" ? (
                <a
                  href={normalizeUrl(row.jobDescription)}
                  target="_blank"
                  className="text-info  hover:underline cursor-pointer"
                  rel="noreferrer"
                >
                  {/* {row.jobDescription}  */}
                  {getSiteName(row.jobDescription)}
                </a>
              ) : (
                "-"
              )}
            </div>
          ),
        },
        { key: "addedBy", label: "Added By" },
        { key: "addedOn", label: "Added On" },
        { key: "modifiedBy", label: "Modified By" },
        { key: "modifiedOn", label: "Modified On" },
      ],
      rows: [
        {
          id: 1,
          clientName: "Acme Corp",
          title: "React Developer",
          location: "New York",
          jobDescription: "Frontend role",
          addedBy: "Jospher",
          modifiedBy: "Mike",
          addedOn: "2024-01-15",
          modifiedOn: "2024-03-15",
        },
        {
          id: 2,
          clientName: "Beta Ltd",
          title: "Java Developer",
          location: "Austin",
          jobDescription: "Backend role",
          addedBy: "Susan",
          modifiedBy: "Ron",
          addedOn: "2024-02-15",
          modifiedOn: "2024-05-15",
        },
        {
          id: 3,
          clientName: "Gamma Inc",
          title: "DevOps Engineer",
          location: "Remote",
          jobDescription: "CI/CD pipeline",
          addedBy: "Nethan",
          modifiedBy: "Susan",
          addedOn: "2024-04-15",
          modifiedOn: "2025-09-15",
        },
      ],
    },

    openJobs: {
      columns: [
        { key: "clientName", label: "Client Name" },
        { key: "title", label: "Job Title" },

        { key: "addedBy", label: "Added By" },
        { key: "addedOn", label: "Added On" },
        { key: "modifiedBy", label: "Modified By" },
        { key: "modifiedOn", label: "Modified On" },
      ],
      rows: [
        {
          id: 1,
          clientName: "Delta Co",
          title: "QA Engineer",
          location: "Chicago",
          jobDescription: "Testing role",
          addedBy: "Mike",
          modifiedBy: "Jospher",
          addedOn: "2024-01-15",
          modifiedOn: "2025-03-15",
        },
        {
          id: 2,
          clientName: "Epsilon Inc",
          title: "Data Analyst",
          location: "Boston",
          jobDescription: "Analytics role",
          addedBy: "Ron",
          modifiedBy: "Nethan",
          addedOn: "2024-04-15",
          modifiedOn: "2026-09-15",
        },
      ],
    },

    placements: {
      columns: [
        { key: "clientName", label: "Client Name" },
        { key: "candidateName", label: "Candidate Name" },
        { key: "jobTitle", label: "Job Title" },
        { key: "location", label: "Location" },
        { key: "addedBy", label: "Added By" },
        { key: "addedOn", label: "Added On" },
        { key: "modifiedBy", label: "Modified By" },
        { key: "modifiedOn", label: "Modified On" },
      ],
      rows: [
        {
          id: 1,
          clientName: "Zeta Corp",
          title: "UI Developer",
          location: "Seattle",
          description: "Design role",
          addedBy: "Susan",
          modifiedBy: "Mike",
          addedOn: "2024-05-15",
          modifiedOn: "2025-06-15",
        },
        {
          id: 2,
          clientName: "Eta Ltd",
          title: "Backend Engineer",
          location: "Dallas",
          description: "Node.js role",
          addedBy: "Jospher",
          modifiedBy: "Ron",
          addedOn: "2024-01-15",
          modifiedOn: "2025-03-15",
        },
      ],
    },

    backout: {
      columns: [
        { key: "clientName", label: "Client Name" },
        { key: "jobTitle", label: "Job Title" },
        { key: "candidateName", label: "Candidate Name" },
        { key: "addedBy", label: "Added By" },
        { key: "addedOn", label: "Added On" },
      ],
      rows: [
        {
          id: 1,
          sNo: 1,
          clientName: "Acme Corp",
          jobTitle: "React Developer",
          candidateName: "John Doe",
          addedBy: "Jospher",
          addedOn: "2024-02-05",
        },
        {
          id: 2,
          sNo: 2,
          clientName: "Beta Ltd",
          jobTitle: "Java Developer",
          candidateName: "Jane Smith",
          addedBy: "Susan",
          addedOn: "2024-01-15",
        },
      ],
    },

    revenue: {
      columns: [
        { key: "source", label: "Source" },
        { key: "amount", label: "Amount" },
        { key: "date", label: "Date" },
      ],
      rows: [
        {
          id: 1,
          source: "Placement Fee",
          amount: "$5,000",
          date: "2024-01-15",
        },
        {
          id: 2,
          source: "Contract",
          amount: "$8,000",
          date: "2024-01-20",
        },
      ],
    },
  };
  const { page, limit, setPage, handleLimitChange } = usePagination(10);
  const [loading, setLoading] = useState(false);
  const [rows, setRows] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [searchValue, setSearchValue] = useState("");
  const config = KPI_CONFIG[selectedKpi] || { columns: [], rows: [] };
  const { columns } = config;

  const mappedRows = mapTableRows(rows, columns);

  //coustom domain function for get allAccounts
  //   const getDomain = (url) => {
  //   if (!url) return "-";
  //   try {
  //     const cleanUrl = url.startsWith("http") ? url : `https://${url}`;
  //     const { hostname } = new URL(cleanUrl);
  //     return hostname.replace("www.", "");
  //   } catch {
  //     return url;
  //   }
  // };

  useEffect(() => {
    const fetchData = async () => {
      try {
        setRows([]);
        switch (selectedKpi) {
          case "totalAccounts": {
            try {
              setLoading(true);
              const filter = {
                addedOn: {
                  type: "DATE_RANGE_Accounts",
                  value: {
                    from: finalDataDuration.from
                      ? getStartOfDay(finalDataDuration.from)
                      : "",
                    to: finalDataDuration.to
                      ? getEndOfDay(finalDataDuration.to)
                      : "",
                    ret: "companyData.uiid companyData.name companyData.website companyData.domain companyData.industry addedByData.firstName addedOn uiid",
                  },
                },
              };

              const response = await getTotalAccountsFromJobsApi({
                pg: page,
                lim: limit,
                fil: filter,
              });
              // const apiData = response?.data?.data || [];
              const apiData = response?.data?.data?.[0]?.actualData || [];

              const formattedData = apiData.map((item, index) => ({
                id: item?.uiid || index + 1,
                clientName: formatWords2(item?.companyData?.name || "-"),
                companyWebsite: item?.companyData?.website || "-",
                companyDomain: item?.companyData?.domain || "-",
                industry: formatWords2(item?.companyData?.industry || "-"),
                location: formatWords2(item?.location?.city || "-"),
                addedBy: formatWords2(item?.addedByData?.firstName || "-"),
                addedOn: item?.addedOn
                  ? new Date(item.addedOn).toLocaleDateString()
                  : "-",
              }));

              setRows(formattedData);
              setTotalCount(response?.data?.data?.[0]?.totalCount);
            } catch (error) {
              console.error("Total Accounts Error:", error);
            } finally {
              setLoading(false);
            }

            break;
          }
          case "positivesjobs": {
            setLoading(true);
            const response = await fetchAllJobs({
              coll: "Job",
              fil: {
                modifiedOn: {
                  type: "DATE_RANGE",
                  value: {
                    from: finalDataDuration.from
                      ? getStartOfDay(finalDataDuration.from)
                      : "",
                    to: finalDataDuration.to
                      ? getEndOfDay(finalDataDuration.to)
                      : "",
                  },
                },
              },
              pg: page,
              lim: limit,
              ret: "uiid title addedBy location status description modifiedBy modifiedOn addedOn",
              ref: "Company",
              extret: "uiid firstName",
              incl: ["name"],
              useAggregate: false,
              sort: JSON.stringify({ modifiedOn: -1 }),
            });
            setLoading(false);
            const formattedData =
              (response?.data?.data || [])?.map((item) => ({
                ...item,
                clientName: formatWords2(item?.companyId?.name || "-"),
                jobDescription: formatWords2(item?.description || "-"),
                id: item?.uiid,
                location: formatWords2(item?.location?.city || "-"),
                addedBy: formatWords2(item?.addedBy?.firstName || "-"),
                modifiedBy: formatWords2(item?.modifiedBy?.firstName || "-"),
                addedOn: item?.addedOn
                  ? new Date(item.addedOn).toLocaleDateString()
                  : "-",
                modifiedOn: item?.modifiedOn
                  ? new Date(item.modifiedOn).toLocaleDateString()
                  : "-",
              })) || [];
            const total = await getTotalCountApi({
              collection: "jobs",
              coll: "Job",
              tname: "prospectsCounts",
              filters: {
                modifiedOn: {
                  type: "DATE_RANGE",
                  value: {
                    from: finalDataDuration.from
                      ? getStartOfDay(finalDataDuration.from)
                      : "",
                    to: finalDataDuration.to
                      ? getEndOfDay(finalDataDuration.to)
                      : "",
                  },
                },
              },
              app: "ats",
            });
            setRows(formattedData);
            setTotalCount(total?.data?.data || 0);

            break;
          }
          case "openJobs": {
            setLoading(true);
            const responseOpenList = await fetchAllJobsApi({
              coll: "JobPosting",
              fil: {
                modifiedOn: {
                  type: "JOBPOSTING_DATE_STATUS",
                  value: 2,
                  startDate: finalDataDuration.from
                    ? getStartOfDay(finalDataDuration.from)
                    : "",
                  endDate: finalDataDuration.to
                    ? getEndOfDay(finalDataDuration.to)
                    : "",
                },
              },
              pg: page,
              lim: limit,
              useAggregate: true,
              extret: "uiid firstName",
            });
            const formattedOpenJobs =
              (responseOpenList?.data?.data[0]?.data || [])?.map((item, index) => ({
                ...item,
                clientName: formatWords2(item?.companyName || "-"),
                title: formatWords2(item?.jobTitle || "-"),
                id: item?.uiid || index + 1,
                addedBy: formatWords2(item?.addedBy?.firstName || item?.addedBy || "-"),
                modifiedBy: formatWords2(item?.modifiedBy?.firstName || item?.modifiedBy || "-"),
                addedOn: item?.addedOn
                  ? new Date(item.addedOn).toLocaleDateString()
                  : "-",
                modifiedOn: item?.modifiedOn
                  ? new Date(item.modifiedOn).toLocaleDateString()
                  : "-",
              })) || [];
            setLoading(false);
            setRows(formattedOpenJobs);
            setTotalCount(responseOpenList?.data?.data[0]?.totalCount || 0);
            break;
          }
          case "placements": {
            setLoading(true);

            try {
              const response = await getPlacementsListApi({
                coll: "Submission",
                useAggregate: true,

                fil: {
                  placementDate: {
                    type: "DATE_RANGE_Placements",
                    value: {
                      status: 63,
                      from: finalDataDuration.from
                        ? getStartOfDay(finalDataDuration.from)
                        : "",
                      to: finalDataDuration.to
                        ? getEndOfDay(finalDataDuration.to)
                        : "",
                    },
                  },
                },

                pg: page,
                lim: limit,
                ret: "uiid candidateName title location jobDescription companyName placedOn addedBy addedOn modifiedBy modifiedOn",
                ref: "Company Candidate JobPosting",
                sort: JSON.stringify({ "placementStatus.addedOn": -1 }),
              });
              const apiData = response?.data?.data?.[0]?.actualData || [];
              const totalCount = response?.data?.data?.[0]?.totalCount || 0;
              const formatDate = (date) => {
                if (!date) return "-";
                return new Date(date).toLocaleDateString();
              };
              const formattedData = apiData.map((item, index) => ({
                id: item?.uiid || index + 1,

                candidateName: formatWords2(item?.candidateName || "-"),
                jobTitle: formatWords2(item?.title || "-"),
                location: (() => {
                  const loc = item?.location;
                  if (!loc) return "-";
                  if (typeof loc === "object") {
                    return formatWords2(
                      loc?.city || loc?.state || loc?.country || "-",
                    );
                  }
                  return formatWords2(loc);
                })(),
                jobDescription: item?.jobDescription || "-",
                clientName: formatWords2(item?.companyName || "-"),
                status: "Placed",
                placedOn: formatDate(item?.placedOn || "-"),
                addedBy: formatWords2(item?.addedBy || "-"),
                addedOn: item?.addedOn ? formatDate(item?.addedOn) : "-",
                modifiedBy: formatWords2(item?.modifiedBy || "-"),
                modifiedOn: item?.modifiedOn
                  ? formatDate(item.modifiedOn)
                  : "-",
              }));
              // console.table("Formatted Placements Data:", apiData);

              setRows(formattedData);
              setTotalCount(totalCount);
            } catch (error) {
              console.error("Placements Error:", error);
            }

            setLoading(false);
            break;
          }
          case "backout": {
            setLoading(true);

            const fromDate = finalDataDuration?.from
              ? getStartOfDay(finalDataDuration.from)
              : "";

            const toDate = finalDataDuration?.to
              ? getEndOfDay(finalDataDuration.to)
              : "";

            const response = await getAdminBackoutsListApi({
              coll: "Submission",
              useAggregate: true,
              pg: page,
              lim: limit,
              fil: {
                modifiedOn: {
                  type: "BACKOUT_STATUS",
                  value: 65,
                  startDate: fromDate,
                  endDate: toDate,
                },
              },
            });

            setLoading(false);
            const apiData = response?.data?.data?.[0]?.data || [];
            const total = response?.data?.data?.[0]?.totalCount || 0;
            const formattedData = apiData.map((item, index) => ({
              id: item?.uiid || index + 1,

              clientName: formatWords2(item?.clientName || "-"),
              jobTitle: formatWords2(item?.jobTitle || "-"),
              candidateName: formatWords2(item?.candidateName || "-"),

              addedBy: formatWords2(item?.addedBy?.firstName || item?.addedBy || "-"),

              addedOn: item?.addedOn
                ? new Date(item.addedOn).toLocaleDateString()
                : "-",
            }));

            setRows(formattedData);
            setTotalCount(total);

            break;
          }
          case "revenue":
            // Fetch data for Revenue KPI
            break;
          default:
            break;
        }
      } catch (error) {
        console.error("Error fetching KPI data:", error);
      }
    };
    fetchData();
  }, [selectedKpi, page, limit, searchValue]);

  const handleServerSearch = (key, val) => {
    setSearchValue(val);
    if (page !== 1) setPage(1);
  };

  return (
    <div>
      <TableAdv
        tableId={`dashboard_${selectedKpi}`}
        rows={rows}
        showSlNo
        columns={columns}
        totalCount={totalCount}
        serverPagination
        page={page}
        limit={limit}
        onPaginationChange={setPage}
        onLimitChange={handleLimitChange}
        serverOnSearch={handleServerSearch}
        serverSearchValue={searchValue}
      />
      <Backdrop isOpen={loading}>
        <LogoLoader />
      </Backdrop>
    </div>
  );
};

export default KpiDashboardViewModal;
